import { IsString } from 'class-validator';

export class ChoiceButtonsDto {
  @IsString()
  readonly id: string | number | boolean;
  @IsString()
  readonly displayText: string | number | boolean;
}
